import { render } from "./MoveCandidates.vue?vue&type=template&id=1b26c07b"
import script from "./MoveCandidates.vue?vue&type=script&lang=js"
export * from "./MoveCandidates.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src511626146/src/application/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__